<template>
  <v-card height="100%" style="position: relative;">
    <div :class="$style.contentsCardContainer">
      <div :class="[$style.contentsCardContainer__thumbnailArea, 'pa-1']">
        <template v-if="publicationType !== 'secure_view'">
          <vc-share-a
            :href="contentsFullWindowUrl"
            :target="isIce ? '_blank' : '_self'"
            :class="$style.contentsCardContainer__thumbnailAreaHover"
          >
            <v-responsive
              :aspect-ratio="1 / Math.sqrt(2)"
              :style="{
                'background-image': 'url(' + thumbnailImageSrc + ')',
                'background-size': 'cover',
                'background-position': 'center'
              }"
            ></v-responsive>
          </vc-share-a>
        </template>
        <template v-else>
          <v-responsive
            :aspect-ratio="1 / Math.sqrt(2)"
            :style="{
              'background-image': 'url(' + thumbnailImageSrc + ')',
              'background-size': 'cover',
              'background-position': 'center'
            }"
          ></v-responsive>
        </template>
      </div>

      <div :class="$style.contentsCardContainer__contentsDetailArea">
        <div :class="$style.contentsDetailContainer">
          <div>
            <template v-if="publicationType !== 'secure_view'">
              <vc-share-a
                :href="contentsUrl"
                :class="[
                  $style.contentsTitleContainer__title,
                  $style.textPositionMiddle,
                  'body-1'
                ]"
                :target="isIce ? '_blank' : '_self'"
              >
                {{ contentsTitle }}
              </vc-share-a>
            </template>
            <template v-else>
              {{ contentsTitle }}
            </template>
            <span
              v-if="!isMyContents"
              :class="[$style.contentsCreatorText, 'caption d-block']"
            >
              {{ creatorName }}
            </span>
            <span :class="[$style.contentsStatusText, 'caption d-block']">
              <span>{{ contentsStatusText }}</span>
            </span>
            <span
              v-if="isMyContents"
              :class="[$style.contentsStatusText, 'caption d-block']"
            >
              <vc-share-date
                :ts="contentsPublishedAtTs"
                :locale="locale"
              ></vc-share-date>
              <span v-if="locale !== 'ja-jp' && locale !== 'zh-tw'">
                - {{ contentsPublishedAtTime }}
              </span>
            </span>
          </div>

          <div :class="[$style.cardActionButtonContainer, 'text-xs-right']">
            <div
              v-if="isMyContents"
              :class="$style.cardActionButtonContainer__summryData"
            >
              <eyeIcon
                :class="[
                  $style.contentsSummary__icon,
                  $style.textPositionMiddle
                ]"
              ></eyeIcon>

              <span
                :class="[
                  $style.textPositionMiddle,
                  $style.contentsSummary__text,
                  'grey--text text--darken-1'
                ]"
              >
                {{ previewCount }}
              </span>
              <template v-if="!this.isLightPlan">
                <commentIcon
                  v-if="isCommentEnabled"
                  :class="[
                    $style.contentsSummary__icon,
                    $style.textPositionMiddle
                  ]"
                ></commentIcon>
                <span v-else style="position:relative;">
                  <banIcon :class="$style.cardActionButtonContainer__banIcon">
                  </banIcon>
                  <commentIcon
                    :class="[
                      $style.contentsSummary__icon,
                      $style.textPositionMiddle
                    ]"
                    style="fill: rgba(0, 0, 0, 0.3);"
                  ></commentIcon>
                </span>
                <span
                  :class="[
                    $style.textPositionMiddle,
                    $style.contentsSummary__text,
                    'grey--text text--darken-1'
                  ]"
                >
                  {{ isCommentEnabled ? commentCount : 0 }}
                </span>
                <heartIcon
                  :class="[
                    $style.contentsSummary__icon,
                    $style.textPositionMiddle
                  ]"
                ></heartIcon>
                <span
                  :class="[
                    $style.textPositionMiddle,
                    $style.contentsSummary__text,
                    'grey--text text--darken-1'
                  ]"
                >
                  {{ favoriteCount }}
                </span>
                <starIcon
                  :class="[
                    $style.contentsSummary__icon,
                    $style.textPositionMiddle
                  ]"
                ></starIcon>
                <span
                  :class="[
                    $style.textPositionMiddle,
                    $style.contentsSummary__text,
                    'grey--text text--darken-1'
                  ]"
                >
                  {{ starCount }}
                </span>
              </template>
            </div>

            <div><slot></slot></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isWallEdit" :class="$style.contentsCardLinkDisabled"></div>
  </v-card>
</template>

<script>
import commentIcon from "./assets/comment.svg";
import heartIcon from "./assets/heart.svg";
import starIcon from "./assets/star.svg";
import eyeIcon from "./assets/eye.svg";
import banIcon from "./assets/ban.svg";

import ice from "../../../lib/ice";

export default {
  name: "vc-share-contents-card",
  components: {
    commentIcon: commentIcon,
    heartIcon: heartIcon,
    starIcon: starIcon,
    eyeIcon: eyeIcon,
    banIcon: banIcon
  },
  props: {
    thumbnailImageSrc: {
      type: String,
      default: ""
    },
    contentsTitle: {
      type: String,
      default: ""
    },
    creatorName: {
      type: String,
      default: ""
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    contentsSize: {
      type: String,
      default: ""
    },
    publicationType: {
      type: String,
      default: ""
    },
    isContentsSensitive: {
      type: Boolean,
      default: false
    },
    contentsUrl: {
      type: String,
      default: ""
    },
    contentsFullWindowUrl: {
      type: String,
      default: ""
    },
    isCommentEnabled: {
      type: Boolean,
      default: false
    },
    isMyContents: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default: () => {
        return {
          contents_type_book: "本",
          contents_type_panel: "パネル",
          contents_type_webtoon: "Webtoon（縦スクロール）作品",
          contents_size: "サイズ",
          contents_set_secret_word: "合言葉",
          contents_set_sensitive: "自主規制"
        };
      }
    },
    canDownloadPrintingData: {
      type: Boolean,
      default: false
    },
    previewCount: {
      type: Number,
      default: 0
    },
    commentCount: {
      type: Number,
      default: 0
    },
    favoriteCount: {
      type: Number,
      default: 0
    },
    starCount: {
      type: Number,
      default: 0
    },
    contentsPublishedAtTs: {
      type: String,
      default: ""
    },
    contentsPublishedAtTime: {
      type: String,
      default: ""
    },
    externalServiceName: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: ""
    },
    isWallEdit: {
      type: Boolean,
      default: false
    },
    isWebtoon: {
      type: Boolean,
      default: false
    },
    isLightPlan: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      contentsStatusText: "",
      displayContentsPublishedAt: "",
      isIce: false
    };
  },
  mounted() {
    this.isIce = ice.isIce();
    let tempContentsStatusText = "";
    if (this.isLightPlan) {
      tempContentsStatusText =
        this.locale === "ja-jp" ? "ライトプラン" : "Light Plan";
      // FIXME: ライトプランが多言語展開されるまでja-jp固定
    } else if (this.isWebtoon) {
      tempContentsStatusText = this.lang.contents_type_webtoon;
    } else {
      tempContentsStatusText = this.isPanel
        ? this.lang.contents_type_panel
        : this.lang.contents_type_book;
      tempContentsStatusText =
        tempContentsStatusText +
        ", " +
        this.contentsSize +
        this.lang.contents_size;
    }
    if (this.publicationType === "secret_word") {
      tempContentsStatusText =
        tempContentsStatusText + ", " + this.lang.contents_set_secret_word;
    }
    if (this.isContentsSensitive) {
      tempContentsStatusText =
        tempContentsStatusText + ", " + this.lang.contents_set_sensitive;
    }
    if (this.isMyContents && this.externalServiceName !== "") {
      tempContentsStatusText =
        tempContentsStatusText + ", " + this.externalServiceName;
    }
    this.contentsStatusText = tempContentsStatusText;
  }
};
</script>

<style lang="scss" module>
.contentsCardContainer {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &__thumbnailArea {
    width: 20%;

    &Hover {
      :hover {
        opacity: 0.5;
      }
    }
  }

  &__contentsDetailArea {
    width: 80%;
  }
}

.contentsDetailContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.contentsTitleContainer {
  &__title {
    text-decoration: none;
    line-height: 0;
  }
}

.contentsSummary {
  &__icon {
    width: 11px;
    height: 11px;
    display: inline-block;
    fill: gray;
  }

  &__text {
    font-size: 11px;
  }
}

.textPositionMiddle {
  vertical-align: middle;
}

.contentsCreatorText {
  line-height: 14px;
}

.contentsStatusText {
  color: gray;
  line-height: 14px;
}

.cardActionButtonContainer {
  position: relative;

  &__summryData {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  &__banIcon {
    fill: red;
    position: absolute;
    width: 11px;
    height: 11px;
    top: 0;
    left: 5px;
  }
}

.contentsCardLinkDisabled {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>
